export const LOCALE_EN = "en";
export const LOCALE_FR = "fr";
export const LOCALE_NL = "nl";

export const localeOptions = {
  LOCALE_FR,
  LOCALE_EN,
  // LOCALE_NL,
};
